import React, { useState, useEffect, useRef } from "react";
import classes from "./DakshPage.module.css";
import Daksh_logo from "../assets/Daksh_logo.png";

const Header = ({ onTechClick, onAccessClick }) => {
  const [showModal, setShowModal] = useState(false);

  const betaRef = useRef(null);

  const scrollToBeta = () => {
    betaRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={classes.header}>
      <img src={Daksh_logo} alt="Daksh" className={classes.logoImg} />

      <div className={classes.nav}>
        <span
          className={classes.tech}
          onClick={onTechClick}
          style={{ cursor: "pointer" }}
        >
          TECHNOLOGY
        </span>
        <button className={classes.terminalBtn} onClick={onAccessClick}>
          GET IN TOUCH
        </button>
      </div>
    </div>
  );
};

export default Header;
